import { LIGHT_THEME } from "../state/actions/theme.action";

export default {
  name: LIGHT_THEME,
  colors: {
    primary: {
      normal: "#ff7700",
      ambient: "#bc752f",
      text: "#ffffff"
    },
    background: {
      normal: "#ff7700",
      ambient: "#fefefe",
      text: "#000000"
    }
  },
  fonts: {}
};
